import { Pagination } from '@mantine/core';
import React from 'react';

interface Props {
  total: number;
  page: number;
  limit?: number;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  paginationRequest?: (page: number, limit: number) => void;
}
function XPagination(props: Props) {
  const { total, page, limit, setPage, paginationRequest } = props;
  return (
    <>
      <Pagination
        total={total}
        page={page}
        onChange={(page: number) =>
          paginationRequest
            ? paginationRequest(page, limit || 20)
            : setPage && setPage(page)
        }
        position='center'
        p='md'
        spacing='md'
        data-cy='pagination'
      />
    </>
  );
}

export default XPagination;
